import React from "react";
import { Loader } from "tabler-icons-react";

/**
 * Composant d'état de chargement
 */
const LoadingState = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Loader className="animate-spin" size={40} />
    </div>
  );
};

export default LoadingState;
